import { render } from "./TPConfirmPop.vue?vue&type=template&id=73371904&scoped=true&ts=true"
import script from "./TPConfirmPop.vue?vue&type=script&lang=ts"
export * from "./TPConfirmPop.vue?vue&type=script&lang=ts"

import "./TPConfirmPop.vue?vue&type=style&index=0&id=73371904&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73371904"]])

export default __exports__